var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDowanload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 15.5,
    stroke: "#EF2E25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 32.8125C35 33.4683 34.4683 34 33.8125 34H17.1875C16.5317 34 16 33.4683 16 32.8125C16 32.1567 16.5317 31.625 17.1875 31.625H33.8125C34.4683 31.625 35 32.1567 35 32.8125ZM24.6603 29.0506C24.8922 29.2825 25.1961 29.3985 25.5 29.3985C25.8039 29.3985 26.1079 29.2825 26.3397 29.0506L30.5471 24.8433C31.0108 24.3795 31.0108 23.6277 30.5471 23.1639C30.0833 22.7002 29.3314 22.7002 28.8677 23.1639L26.6875 25.3441V16.1875C26.6875 15.5317 26.1558 15 25.5 15C24.8442 15 24.3125 15.5317 24.3125 16.1875V25.3441L22.1323 23.1639C21.6686 22.7002 20.9167 22.7002 20.4529 23.1639C19.9892 23.6277 19.9892 24.3795 20.4529 24.8433L24.6603 29.0506Z",
    fill: "#EF2E25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowanload);
export default __webpack_public_path__ + "static/media/dowanload.68fd4e39623cb2fea1aa0f33e8f1d083.svg";
export { ForwardRef as ReactComponent };